import { Icon } from './Icon';
import { STEPS } from '../data';

export function HowItWorks() {
  return (
    <section className="py-16 how-section" id="how">
      <div className="mx-auto w-full max-w-[1180px] px-7">
        <div className="reveal max-w-[680px] mx-auto mb-14 text-center">
          <span className="lp-eyebrow"><Icon name="zap" size={13} /> How it works</span>
          <h2 className="text-[clamp(28px,3.6vw,42px)] font-bold tracking-[-0.03em] leading-[1.1] mt-4">Live in 20 minutes, not 20 days</h2>
        </div>
        <div className="how-grid reveal reveal-stagger">
          {STEPS.map((s, i) => (
            <div className="how-step" key={s.n}>
              {i < STEPS.length - 1 ? <div className="how-connector" /> : null}
              <div className="how-num">{s.n}</div>
              <h4>{s.title}</h4>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
